import $ from 'jquery';
window.$ = window.$ || $;
window.jQuery = window.jQuery || $;

import 'select2/dist/css/select2.css';
import 'select2';

const initMemberDirectoryFilters = () => {
  const selects = document.querySelectorAll('[data-member-directory-state]');
  if (!selects.length) {
    return;
  }

  selects.forEach((select) => {
    const $select = $(select);
    if ($select.data('select2')) {
      return;
    }

    $select.select2({
      width: '100%',
      placeholder: 'Filter by state',
      allowClear: true,
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMemberDirectoryFilters);
} else {
  initMemberDirectoryFilters();
}

const initMemberDirectoryMap = () => {
  const maps = document.querySelectorAll('[data-member-directory-map]');
  if (!maps.length) {
    console.info('[MemberDirectoryMap] No map containers found.');
    return false;
  }
  if (
    typeof window.google === 'undefined' ||
    !window.google.maps ||
    typeof window.google.maps.Map !== 'function' ||
    typeof window.google.maps.Marker !== 'function'
  ) {
    console.warn('[MemberDirectoryMap] Google Maps API not available yet.', {
      googleDefined: typeof window.google !== 'undefined',
      hasMaps: !!(window.google && window.google.maps),
      hasMapConstructor: typeof window.google?.maps?.Map === 'function',
      hasMarkerConstructor: typeof window.google?.maps?.Marker === 'function',
    });
    return false;
  }

  maps.forEach((container) => {
    if (container.dataset.mapInitialized === 'true') {
      return;
    }

    const data = container.dataset.mapPins;
    if (!data) {
      console.warn('[MemberDirectoryMap] Missing data-map-pins on container.', container);
      return;
    }

    let pins = [];
    try {
      pins = JSON.parse(data);
    } catch (error) {
      console.error('[MemberDirectoryMap] Failed to parse pins JSON.', error, data);
      return;
    }

    if (!Array.isArray(pins) || !pins.length) {
      console.warn('[MemberDirectoryMap] Pins data empty after parsing.', pins);
      return;
    }

    const map = new window.google.maps.Map(container, {
      center: { lat: pins[0].lat, lng: pins[0].lng },
      zoom: 6,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    console.info('[MemberDirectoryMap] Map initialized.', {
      pinCount: pins.length,
      firstPin: pins[0],
    });

    const bounds = new window.google.maps.LatLngBounds();
    const sharedInfoWindow = new window.google.maps.InfoWindow();

    map.addListener('click', () => {
      sharedInfoWindow.close();
    });

    pins.forEach((pin) => {
      const position = { lat: Number(pin.lat), lng: Number(pin.lng) };
      if (!Number.isFinite(position.lat) || !Number.isFinite(position.lng)) {
        console.warn('[MemberDirectoryMap] Skipping invalid pin coordinates.', pin);
        return;
      }

      const marker = new window.google.maps.Marker({
        position,
        map,
      });

      const addressLines = [pin.addressLine1, pin.addressLine2, `${pin.city} ${pin.state} ${pin.zip}`]
        .filter(Boolean)
        .join('<br>');

      const infoHtml = `
        <div class="bg-white rounded-lg shadow-lg p-4">
          <h3 class="font-bold text-primary text-lg mb-1">${pin.organization ?? ''}</h3>
          <p class="text-gray-700 text-sm mb-2">
            ${addressLines}
          </p>
          <p class="text-secondary font-bold text-sm">
            ${pin.phone ? `${pin.phone}` : ''}
          </p>
          <p class="text-accent-700 text-sm">
            ${pin.email ? `${pin.email}` : ''}
          </p>
        </div>
      `;

      marker.addListener('click', () => {
        sharedInfoWindow.setContent(infoHtml);
        sharedInfoWindow.open({ map, anchor: marker });
      });
      bounds.extend(position);
    });

    if (pins.length === 1) {
      const single = pins[0];
      const singlePosition = { lat: Number(single.lat), lng: Number(single.lng) };
      if (Number.isFinite(singlePosition.lat) && Number.isFinite(singlePosition.lng)) {
        map.setCenter(singlePosition);
        map.setZoom(13);
      }
    } else {
      map.fitBounds(bounds);
      const listener = window.google.maps.event.addListener(map, 'idle', () => {
        if (map.getZoom() > 13) {
          map.setZoom(13);
        }
        window.google.maps.event.removeListener(listener);
      });
    }

    container.dataset.mapInitialized = 'true';
  });

  return true;
};

const scheduleMapRetry = () => {
  let attempts = 0;
  const maxAttempts = 20;

  const interval = setInterval(() => {
    attempts += 1;
    if (initMemberDirectoryMap() || attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 250);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!initMemberDirectoryMap()) {
      scheduleMapRetry();
    }
  });
} else if (!initMemberDirectoryMap()) {
  scheduleMapRetry();
}

window.initMemberDirectoryMap = () => {
  if (!initMemberDirectoryMap()) {
    scheduleMapRetry();
  }
  window.__pendingMemberDirectoryMap = false;
};

if (window.__pendingMemberDirectoryMap) {
  if (!initMemberDirectoryMap()) {
    scheduleMapRetry();
  }
  window.__pendingMemberDirectoryMap = false;
}